export default {
  PHONE_WIDTH: 480,
  TABLET_WIDTH: 768,
  DESKTOP_WIDTH: 980,
};
